"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MINDSET_INTEGRATION_FEATURE_KEYS = void 0;
exports.parseMindsetIntegrationFeaturePolicyInput = parseMindsetIntegrationFeaturePolicyInput;
exports.parseMindsetIntegrationFeaturePolicyUpdate = parseMindsetIntegrationFeaturePolicyUpdate;
exports.parseMindsetIntegrationFeaturePolicyResponse = parseMindsetIntegrationFeaturePolicyResponse;
exports.MINDSET_INTEGRATION_FEATURE_KEYS = ["messaging", "audioCalls", "videoCalls", "groupCalls", "attachments", "voiceNotes", "callRecording", "callReactions", "scheduledCalls"];
function exact(value, keys) {
    if (!value || typeof value !== "object" || Array.isArray(value) ||
        Object.keys(value).length !== keys.length || keys.some(key => !Object.prototype.hasOwnProperty.call(value, key)))
        throw new TypeError("Invalid feature policy shape");
    return value;
}
function identifier(value, max) {
    return typeof value === "string" && value.length > 0 && value.length <= max && value.trim() === value && !/[\u0000-\u001f\u007f-\u009f]/.test(value);
}
function strings(value, max, valid) {
    if (!Array.isArray(value) || value.length > max || new Set(value).size !== value.length || !value.every(valid))
        throw new TypeError("Invalid feature policy values");
}
function parseMindsetIntegrationFeaturePolicyInput(value) {
    const policy = exact(value, ["disabledFeatures", "groups"]);
    const features = (value) => strings(value, 9, item => exports.MINDSET_INTEGRATION_FEATURE_KEYS.includes(item));
    features(policy.disabledFeatures);
    if (!Array.isArray(policy.groups) || policy.groups.length > 32)
        throw new TypeError("At most 32 groups are allowed");
    const ids = new Set();
    for (const value of policy.groups) {
        const group = exact(value, ["id", "name", "disabledFeatures", "memberUserIds"]);
        if (typeof group.id !== "string" || !/^[a-z][a-z0-9-]{0,63}$/.test(group.id) || ids.has(group.id) || !identifier(group.name, 80))
            throw new TypeError("Invalid or duplicate group ID/name");
        ids.add(group.id);
        features(group.disabledFeatures);
        strings(group.memberUserIds, 500, item => identifier(item, 255));
    }
    return value;
}
function parseMindsetIntegrationFeaturePolicyUpdate(value) {
    const input = exact(value, ["expectedRevision", "policy"]);
    if (!Number.isSafeInteger(input.expectedRevision) || input.expectedRevision < 0 || input.expectedRevision > 2147483646)
        throw new TypeError("Invalid feature policy revision");
    parseMindsetIntegrationFeaturePolicyInput(input.policy);
    return value;
}
function parseMindsetIntegrationFeaturePolicyResponse(value, applicationId) {
    const response = exact(value, ["featurePolicy"]);
    const snapshot = exact(response.featurePolicy, ["applicationId", "revision", "canManage", "features", "policy", "branding"]);
    if (snapshot.applicationId !== applicationId || !Number.isSafeInteger(snapshot.revision) || snapshot.revision < 0 || typeof snapshot.canManage !== "boolean")
        throw new TypeError("Invalid feature policy scope");
    const policy = parseMindsetIntegrationFeaturePolicyInput(snapshot.policy);
    const branding = exact(snapshot.branding, ["mode", "attribution", "attributionRequired"]);
    if (branding.mode !== "co-branded" || branding.attribution !== "Powered by Mindset" || branding.attributionRequired !== true)
        throw new TypeError("Invalid attribution policy");
    if (!Array.isArray(snapshot.features) || snapshot.features.length !== 9)
        throw new TypeError("Incomplete feature catalog");
    const keys = new Set();
    for (const item of snapshot.features) {
        const row = exact(item, ["key", "label", "planEnabled", "runtimeAvailable", "companyEnabled", "effectiveEnabled"]);
        if (!exports.MINDSET_INTEGRATION_FEATURE_KEYS.includes(row.key) || keys.has(row.key) || !identifier(row.label, 160) ||
            typeof row.planEnabled !== "boolean" || typeof row.runtimeAvailable !== "boolean" || typeof row.companyEnabled !== "boolean" || typeof row.effectiveEnabled !== "boolean" ||
            row.companyEnabled !== !policy.disabledFeatures.includes(row.key) || row.effectiveEnabled !== (row.planEnabled && row.runtimeAvailable && row.companyEnabled))
            throw new TypeError("Invalid effective feature availability");
        keys.add(row.key);
    }
    return response.featurePolicy;
}
//# sourceMappingURL=integration-feature-policy.js.map